import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import Button from '@wix/da-shared-react/pkg/Button';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiComment } from '@wix/da-types-papi';
import { CommentSubject } from './types';
import MyComment from './MyComment';

import reduxConnectContainer from './MyComments.container';
import s from './MyComments.scss';

export interface Props {
  moduleId: number;
  isOwner: boolean;
  items: {
    subject: CommentSubject;
    comment: PapiComment;
  }[];
  hasMore: boolean;
  isFetching: boolean;
  className?: string;
  fetchMore?: () => void;
}

const enhance = compose(
  reduxConnectContainer,
  withTranslation()
);
export class MyComments extends React.Component<Props & WithTranslation> {
  render() {
    const { hasMore, items, isOwner, t } = this.props;
    return (
      <div className={classnames(s['root'], this.props.className)}>
        <div className={s['comments']}>
          {items &&
            items
              .filter(item => !!item.comment)
              .map(({ subject, comment }, idx) => (
                <MyComment
                  className={s['item']}
                  subject={subject}
                  comment={comment}
                  isOwner={isOwner}
                  key={idx}
                />
              ))}
        </div>
        {items && hasMore && (
          <Button view="b8" onClick={this.fetchMore} fullWidth>
            {t!('common.loadMore')}
          </Button>
        )}
      </div>
    );
  }

  fetchMore = () => {
    this.props.fetchMore && this.props.fetchMore();
  };
}

export default enhance(MyComments) as React.ComponentType<Props>;
